import { constants } from "@newsela/angelou";

const { colors } = constants;

export const headerTextContainerCss = {
  display: "flex",
  flexDirection: "column",
};

export const subHeaderTextCss = {
  fontSize: "12px",
  letterSpacing: "1px",
  margin: "0 0 5px 0",
  alignSelf: "center",
  color: colors.ui.neutral[400],
};

export const headerTextCss = {
  margin: 0,
};
